import {
  autocompletion,
  type CompletionContext,
  type CompletionResult,
} from '@codemirror/autocomplete'

import { allCompletionList } from './template-variable-autocomplete.config'

/**
 * Checks whether the cursor is currently inside an unclosed `{` block
 * by scanning backwards from the cursor position.
 */
const isInsideVariableBlock = (text: string, pos: number): boolean => {
  for (let i = pos - 1; i >= 0; i--) {
    if (text[i] === '}') return false
    if (text[i] === '{') return true
  }
  return false
}

/**
 * CompletionSource that provides template variable validator suggestions.
 * Activates when typing `:` inside a `{...}` variable block.
 */
const templateVariableCompletionSource = (context: CompletionContext): CompletionResult | null => {
  const beforeCursor = context.matchBefore(/:[a-zA-Z]*$/)
  if (!beforeCursor) return null

  const docText = context.state.doc.toString()
  if (!isInsideVariableBlock(docText, beforeCursor.from)) return null

  return {
    from: beforeCursor.from + 1,
    options: allCompletionList,
    validFor: /^[a-zA-Z]*$/,
  }
}

/**
 * CodeMirror 6 autocompletion extension configured for template variable validators.
 * Suggests type validators, constraint validators, and modifier validators
 * when the user types `:` inside a `{...}` variable block.
 */
export const templateVariableAutocomplete = autocompletion({
  override: [templateVariableCompletionSource],
  activateOnTyping: true,
  icons: false,
})
